import { trim } from '@anypromo/shared/utils/helper'
import { ProductSpecModel } from '../model'
import { OrderType, type PriceInfo, type ProductSpec, type ProductSpecColorInfo, type ProductSpecItem } from '../types'
import { type LastCartItem } from './use-last-cart'
import { getSpecListByPriceList } from './use-price'
import { getMinQty } from './use-quantity'
import { useGlobal, useWindow } from './use-window'
import { useOrder } from './use-order'

/**
 * 根据price list创建product spec数据
 * @param orderType 订单类型
 * @param priceList
 * @returns
 */
export function createProductSpec (
  priceList: PriceInfo[],
  qty: number,
  cartInfo?: LastCartItem
): ProductSpecModel {
  const { productSpecList } = useWindow()
  const { isApparelCate } = useGlobal()

  const { buyQty, orderType } = useOrder()

  const selectedItems: ProductSpecColorInfo[] = []
  productSpecList.forEach((it) => {
    let defaultVal: ProductSpecItem | undefined;
    // 如果有price list优先用price list里的数据
    if (priceList.length > 0) {
      priceList.some(priceInfo => {
        //如果有限制的话
        if (priceInfo.SpecLimitation[it.name] && priceInfo.SpecLimitation[it.name].length > 0) {
          const values = it.values.filter(f => priceInfo.SpecLimitation[it.name].includes(f.value))
          if (values.length > 0) {
            defaultVal = values[0];
            return true;
          }
        }
      })

    }
    if (!defaultVal) {
      defaultVal = it.values.find((f) => f.enabled && !f.selected)
    }

    if (cartInfo) {
      const cartValues = cartInfo.ProductOptions.filter((f) => f[it.name]).map(
        (f: any) => f[it.name]
      )
      const values = it.values.filter(
        (f: any) =>
          f.enabled &&
          !f.selected &&
          cartValues.every((val: any) => val === f.value)
      )
      if (values.length > 0) {
        defaultVal = values[0]
      }
    }

    if (defaultVal) {
      selectedItems.push({
        name: it.name,
        value: defaultVal
      })

    }

  })

  const searchParams = new URLSearchParams(window.location.search)
  const paramSpec = searchParams.get('spec')

  if (paramSpec) {
    const arr = paramSpec.split('_')
    const tmpSpecObj: ProductSpecColorInfo[] = []
    if (arr.length > 1) {
      if (arr[1].indexOf('-') !== -1) {
        // 开始解析，先把-替换成空格
        for (let i = 1; i < arr.length; i++) {
          productSpecList.some(function (item) {
            // 先把spec name的空格都替换成-
            const sename = trim(
              item.name.replace(/[^a-zA-Z0-9-_ ]/g, '')
            ).replace(/[ ]+/g, '-')
            if (arr[i].substring(0, sename.length) === sename.toLowerCase()) {
              const value = arr[i].substring(sename.length + 1)
              item.values.some(function (val) {
                //
                const seVal = trim(
                  val.value.replace(/[^a-zA-Z0-9-_ ]/g, '')
                ).replace(/[ ]+/g, '-')

                if (seVal.toLowerCase() === value.toLowerCase()) {
                  tmpSpecObj.push({ name: item.name, value: val })
                  return true
                }
                return false
              })
              return true
            }
            return false
          })
        }
      }
      if (tmpSpecObj.length > 0) {
        selectedItems.splice(0)
        selectedItems.push(...tmpSpecObj)
      }
    }
  }
  const priceSpecModel = new ProductSpecModel()
  let minQty = getMinQty(priceList)
  // 如果url里传递是数量大于最小数量，那就用URL里传递的数量
  if (qty > minQty) {
    minQty = qty
  }

  priceSpecModel.setProductSpec(selectedItems)
  if (Array.isArray(priceSpecModel.quantity)) {
    // 如果是服饰类商品
    if (isApparelCate) {
      const keys = Object.keys(buyQty)
      if (keys.length < 2) {
        priceSpecModel.quantity[0].quantity = minQty

      } else {

        Object.keys(buyQty).forEach(key => {
          const qty = buyQty[key];
          if (Array.isArray(priceSpecModel.quantity)) {
            const qtyObj = priceSpecModel.quantity.find(item => item.size === key);
            if (qtyObj) {
              qtyObj.quantity = qty;
            }
          }
        });
      }
    } else {
      priceSpecModel.quantity[0].quantity = minQty
    }
    if (orderType == OrderType.SpecSample) {
      console.log(orderType)
      priceSpecModel.quantity.forEach(it => {
        if (it.quantity != '' && it.quantity > 0) {
          priceSpecModel.specSampleSizeType = it.size;
        }
      })
    }
  } else {
    priceSpecModel.quantity.quantity = minQty
  }

  return priceSpecModel
}
